import axios from 'axios';

const getQuestionnaireTemplate = id =>
  axios.get(
    `/questionnaire_templates/get_questionnaire_template/?template_id=${id}`,
  );
const getAllQuestionnaireTemplatesInfo = () =>
  axios.get(`/questionnaire_templates/get_all_questionnaire_templates_info`);
const createQuestionnaireTemplate = questionnaireTemplate =>
  axios.post(
    `/questionnaire_templates/create_questionnaire_template`,
    questionnaireTemplate,
  );
const duplicateTemplate = id =>
  axios.post(`/questionnaire_templates/duplicate_template`, {
    id,
  });
const duplicateQuestionToOtherTemplate = ({ questionId, targetTemplateId }) =>
  axios.post('/questionnaire_templates/duplicate_question_to_other_template', {
    question_id: questionId,
    target_template_id: targetTemplateId,
  });
const updateQuestionnaireTemplate = questionnaireTemplate =>
  axios.post(
    `/questionnaire_templates/update_questionnaire_template`,
    questionnaireTemplate,
  );
const deleteQuestionnaireTemplate = id =>
  axios.get(`/questionnaire_templates/delete_questionnaire_template/?id=${id}`);
const exportTemplate = ({ questionnaireTemplateId, sections, format }) =>
  axios.post(`/questionnaire_templates/export_template`, {
    sections,
    format,
    questionnaire_template_id: questionnaireTemplateId,
  });
const updateQuestion = question =>
  axios.post(`/questionnaire_templates/update_question`, question);

const deleteQuestion = ({ id, setId }) =>
  axios.post(`/questionnaire_templates/delete_question`, {
    id,
    set_id: setId,
  });
const deleteSection = ({ questionnaireTemplateId, sectionId }) =>
  axios.post(
    `/questionnaire_templates/${questionnaireTemplateId}/delete_section`,
    {
      section_id: sectionId,
    },
  );
const addSection = ({
  questionnaireTemplateId,
  sectionName,
  sectionType,
  instruction,
}) =>
  axios.post(
    `/questionnaire_templates/${questionnaireTemplateId}/add_section`,
    {
      name: sectionName,
      section_type: sectionType,
      instruction: instruction,
    },
  );
const saveSection = section =>
  axios.post(`/questionnaire_templates/save_section`, section);
const createQuestion = ({
  followUpQuestionId,
  triggerForFollowUpQuestion,
  questionType,
  questionnaireTemplateId,
  ...rest
}) =>
  axios.post(`/questionnaire_templates/create_question`, {
    follow_up_question_id: followUpQuestionId,
    trigger_for_follow_up_question: triggerForFollowUpQuestion,
    question_type: questionType,
    questionnaire_template_id: questionnaireTemplateId,
    ...rest,
  });
const getSignUpLink = ({ id, taxYear, firmGroupId }) =>
  axios.get(`/questionnaire_templates/${id}/get_sign_up_link`, {
    params: {
      id,
      tax_year: taxYear,
      firm_group_id: firmGroupId,
    },
  });
const attachDocumentToQuestion = ({ id, documentName, questionId }) => {
  return axios.post(
    `/questionnaire_templates/${id}/attach_document_to_question`,
    {
      document_name: documentName,
      question_id: questionId,
    },
  );
};
const deleteAttachedDocument = ({ id, questionId }) =>
  axios.get(
    `/questionnaire_templates/${id}/delete_attached_document?question_id=${questionId}`,
  );
const getTemporaryUploadLinkForQuestionnaireTemplate = () =>
  axios.get(
    '/questionnaire_templates/get_temporary_upload_link_for_questionnaire_template',
  );
const sendPreviewToMe = questionnaireTemplateId =>
  axios.post(
    `/questionnaire_templates/${questionnaireTemplateId}/send_preview_to_me`,
    {},
  );
export default {
  updateQuestion,
  deleteQuestion,
  deleteSection,
  addSection,
  saveSection,
  getQuestionnaireTemplate,
  getAllQuestionnaireTemplatesInfo,
  createQuestionnaireTemplate,
  duplicateTemplate,
  duplicateQuestionToOtherTemplate,
  updateQuestionnaireTemplate,
  deleteQuestionnaireTemplate,
  exportTemplate,
  createQuestion,
  getSignUpLink,
  attachDocumentToQuestion,
  deleteAttachedDocument,
  getTemporaryUploadLinkForQuestionnaireTemplate,
  sendPreviewToMe,
};
